import state from './module-connect-taxaxion-event-state';
import mutations from './module-connect-taxaxion-event-mutations';
import getters from './module-connect-taxaxion-event-getters';
export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	getters
};
